export default __webpack_public_path__ + "static/media/google-play-2x.7d2d365e.png";